import React from 'react';

import { Route, Switch, useRouteMatch } from 'react-router-dom';

import { NotAuthorized } from 'app/components/not-authorized';
import { CardContainer } from 'app/components/shared/card-container';
import AddFareMediaIssuer from 'app/configuration/fare-media-issuers/addFareMediaIssuer';
import FareMediaIssuersTable from 'app/configuration/fare-media-issuers/FareMediaIssuersTable';
import UpdateFareMediaIssuer from 'app/configuration/fare-media-issuers/updateFareMediaIssuer';
import ViewFareMediaIssuer from 'app/configuration/fare-media-issuers/view-FareMediaIssuer';
import { trimTrailingSlash, useTypedSelector } from 'helpers';
import { hasWriteAccessToFareMediaIssuers } from 'selectors';

const FareMediaIssuers: React.FC = () => {
  const match = useRouteMatch();
  const baseURL = trimTrailingSlash(match.url);

  const hasWriteAccess = useTypedSelector(hasWriteAccessToFareMediaIssuers);

  return (
    <CardContainer>
      <Switch>
        <Route path={`${baseURL}/new`}>
          {hasWriteAccess ? <AddFareMediaIssuer /> : <NotAuthorized />}
        </Route>

        <Route path={`${baseURL}/:id/edit`}>
          {hasWriteAccess ? <UpdateFareMediaIssuer /> : <NotAuthorized />}
        </Route>

        <Route path={`${baseURL}/:id`}>
          <ViewFareMediaIssuer />
        </Route>

        <Route exact path={`${baseURL}`}>
          <FareMediaIssuersTable />
        </Route>
      </Switch>
    </CardContainer>
  );
};

export { FareMediaIssuers };
